import React from 'react';

interface CanvasViewProps {
  canvasRef: React.RefObject<HTMLCanvasElement>;
  onDragOver?: (e: React.DragEvent) => void;
  onDrop?: (e: React.DragEvent) => void;
  onDragLeave?: (e: React.DragEvent) => void;
  cursor?: string;
}

export const CanvasView: React.FC<CanvasViewProps> = ({ 
  canvasRef, 
  onDragOver, 
  onDrop, 
  onDragLeave,
  cursor = 'default'
}) => {
  return (
    <canvas 
      ref={canvasRef} 
      id="bannerCanvas"
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragLeave={onDragLeave}
      style={{ cursor }}
    />
  );
};


